import React from 'react';
import { Button, Select, Checkbox, Row, Col, Typography } from 'antd';
import IssueCardButtonListItem from './IssueCardButtonListItem';
import { PlusOutlined } from '@ant-design/icons';
const { Option } = Select;
const { Text } = Typography;

const IssueCardAction = (props) => {
  const {
    showAllDropdownActions,
    setShowAllDropdownActions,
    buttonActions,
    customizeButtonsError,
    updateCustomButtons,
    all_issuetype_fields,
    addNewButtonAction,
    deleteButtonRow,
  } = props;
  const actionButtonOptions = () => {
    return [];
  };
  const usedButtonActions = buttonActions.map((item) => item.value);
  return (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <Text style={{ flexBasis: '20%' }}>Name</Text>
        </Col>
        <Col>
          <Text style={{ flexBasis: '20%' }}>Action</Text>
        </Col>
      </Row>
      <br />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {buttonActions.map((actionButton, index) => (
          <IssueCardButtonListItem
            actionErrors={customizeButtonsError[index + 1]}
            deleteButtonRow={deleteButtonRow}
            key={index}
            index={index}
            updateCustomButtons={updateCustomButtons}
            all_issuetype_fields={all_issuetype_fields}
            actionButton={actionButton}
            usedButtonActions={usedButtonActions}
          />
        ))}
      </div>
      <div style={{ margin: '1rem 0' }}>
        <Button
          disabled={
            buttonActions &&
            buttonActions.length > 0 &&
            !buttonActions[buttonActions.length - 1].value
          }
          onClick={() => {
            addNewButtonAction();
          }}
        >
          <PlusOutlined /> Add Action
        </Button>
      </div>
      <Checkbox
        checked={showAllDropdownActions}
        onChange={setShowAllDropdownActions}
      >
        Show all actions in dropdown menu in Slack.
      </Checkbox>
    </>
  );
};
export default IssueCardAction;
